<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Jogos</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <puzzle-template-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import { MODEL } from '../components/PuzzleModel';
import PuzzleTemplatePage from '../components/PuzzleTemplatePage.vue';

export default {
  name: 'puzzle-template-create',
  components: {
    PuzzleTemplatePage,
  },
  computed: {},
  methods: {
    ...mapActions(['setPuzzle']),
  },
  created() {
    Events.$emit('sidebarVisible', false);
    this.setPuzzle(cloneDeep(MODEL));
  },
};
</script>
